enum rdUnitType {
  Standard,
  Ambulatory,
  Ada,
  AlcoveStandard,
  AlcoveAda,
}

export default rdUnitType;
